/**
 * @hidden
 **/
// eslint-disable-next-line @typescript-eslint/naming-convention
var _TimeToken = /** @class */ (function () {
    function _TimeToken() {
        this._timeElapsedQueryEnded = false;
    }
    return _TimeToken;
}());
export { _TimeToken };
//# sourceMappingURL=timeToken.js.map